import axios from 'axios';
import Polyglot from 'node-polyglot';
import './polyfills';
import configureRedactor from './configureRedactor';
import configureFormValidation from './configureFormValidation';
import articleEditor from './features/articleEditor/renderInto';
import campaignCreator from './features/campaignCreator/renderInto';
import campaignEditor from './features/campaignEditor/renderInto';
import donation from './features/donation/renderInto';
import enableTooltips from './features/components/enableTooltips';
import login from './features/login/renderInto';
import notification from './features/notification/renderInto';
import passwordReset from './features/passwordReset/renderInto';
import profileEditor from './features/profileEditor/renderInto';
import cookieConsent from './features/cookieConsent/renderInto';
import cookieLink from './features/cookieLink/renderInto';
import { renderInto as shareButton } from './features/facebook/ShareButton';
import translator from './utils/translator';
import { unitAndEst } from './utils/est';
import * as formatters from './utils/i18n';

configureRedactor();
configureFormValidation();

window.app = {
  features: {
    articleEditor,
    campaignCreator,
    campaignEditor,
    donation,
    cookieConsent,
    cookieLink,
    fb: {
      shareButton
    },
    login,
    notification,
    passwordReset,
    profileEditor,
  },
  utils: {
    enableTooltips,
    translator,
    axios,
    est: { unitAndEst },
    formatters
  },
  Polyglot
};

export default window.app;



// WEBPACK FOOTER //
// ./app/Assets/js/index.js